import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Who is Webdpro best for?",
      answer: "Webdpro is designed for SMEs, local businesses, and entrepreneurs who need a professional website but lack technical skills or budget for expensive agencies. Perfect for restaurants, clinics, retail stores, and service providers."
    },
    {
      question: "How quickly can I get my website live?",
      answer: "Most businesses go live within 48 hours. Our industry-specific templates and automated setup process mean you can have a professional website running in minutes, not months."
    },
    {
      question: "Do I need technical skills to use Webdpro?",
      answer: "Not at all! Our drag-and-drop builder requires zero coding knowledge. We also provide onboarding support to get you started quickly, and 24/7 customer support if you need help."
    },
    {
      question: "Can you build and manage everything for me?",
      answer: "Yes! We offer full-service website creation and management. Just provide your content and we'll handle design, launch, and ongoing maintenance so you can focus on running your business."
    },
    {
      question: "What's included in the price?",
      answer: "Everything you need for a professional website: hosting, domain, SSL certificate, templates, payment integration, analytics, and support. No hidden fees or surprise charges."
    },
    {
      question: "Do you offer white-label or agency plans?",
      answer: "Yes, we have partner programs for digital agencies and consultants who want to offer Webdpro to their clients under their own brand. Contact our sales team for details."
    },
    {
      question: "Can I migrate my existing website?",
      answer: "Absolutely. We offer free website migration services to seamlessly transfer your existing site to our platform with no downtime. Our team handles the technical work while you keep your content."
    },
    {
      question: "What kind of support do you provide?",
      answer: "We offer 24/7 customer support through live chat, email, and phone. Premium plans include dedicated account managers for personalized assistance and faster response times."
    }
  ];

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">Everything you need to know about our platform</p>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-toggle">
                  {activeIndex === index ? '-' : '+'}
                </span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;